export default {
  root: {
    borderRadius: 8,
  },
  notchedOutline: {
    borderColor: 'rgba(0,0,0,0.15)'
  }
};
